<template>
  <el-dialog
    v-if="visible"
    :custom-class="$style.dialog"
    :visible="true"
    title="添加银行卡"
    @close="$emit('close')"
  >
    <Loading :loading="loading">
      <el-table
        :data="showList"
        :fit="true"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          property="username"
          label="开户人"
          align="center"
          width="120"
        />

        <el-table-column
          property="bankName"
          label="银行名称"
          align="center"
          width="120"
        />

        <el-table-column
          property="cardNumber"
          label="账号尾数（后4位）"
          align="center"
          width="100"
        />

        <el-table-column
          property="createdTime"
          label="添加日期"
          align="center"
          width="100"
        />

        <el-table-column
          property="locBusinessName"
          label="操作"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <div>
              <span
                :class="$style.delete"
                @click.stop="deleteBankcard(scope.row.id)"
              >
                删除
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </Loading>
  </el-dialog>
</template>

<script>
import { getBankCard, deleteBankcard } from "@server";

export default {
  name: "MyBankPopup",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      page: 1,
      limit: 10,
      showList: [],
      total: 0,
    };
  },
  methods: {
    async getBankCard(page = 1) {
      this.page = page;
      this.loading = true;
      const params = {
        page: 1,
        limit: this.limit,
      };
      const res = await getBankCard(params);

      if (res.code == 200) {
        this.cardList = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    },

    deleteBankcard(id) {
      this.$confirm(`确定要删除此银行卡吗？`, "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await deleteBankcard(id);

          if (res.code === 200) {
            this.$message({ message: "删除成功!", type: "success" });
            this.getBankCard();
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    handlePageChange(page) {
      this.getBankCard(page);
    },
  },
  created() {
    this.getBankCard();
  },
};
</script>

<style lang='scss' module scoped>
::v-deep .dialog {
  width: 800px;

  :global {
    .el-table {
      min-height: 300px;
      max-height: 60vh;
      padding-right: 10px;
      @include scrollbar();
    }

    .el-pagination {
      padding-top: rem(20);
      border-top: $border-1;
      @include flex();
    }
  }

  .delete {
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }
}
</style>
